export function closeModal(method, timeout = 300) {
    if (!method) return;
    setTimeout(() => {
        method();
    }, timeout);
}
